import { resolveVersion, versions } from 'utils/versioning';

const companyTimezone = resolveVersion({
  [versions.alpha]: 'America/New_York',
  [versions.global]: 'America/New_York',
  [versions.west]: 'America/Los_Angeles',
});

export { companyTimezone };
